import { render, staticRenderFns } from "./DashboardMetrics.vue?vue&type=template&id=5f89bc70&scoped=true&"
import script from "./DashboardMetrics.vue?vue&type=script&lang=js&"
export * from "./DashboardMetrics.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMetrics.vue?vue&type=style&index=0&id=5f89bc70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f89bc70",
  null
  
)

export default component.exports